import React, { Component } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Loader } from 'semantic-ui-react'

import TopicleCell from './TopicleCell'

class TopiclesColumn extends Component {

  handleTopicleSelected = (topicle) => {
    this.props.onTopicleSelected(topicle)
  }

  render () {
    const { hasMore, topicles, selectedTopicle, infiniteScroll } = this.props

    let topicleCells = topicles.map((topicle, i) => (
      <TopicleCell
        topicle={topicle}
        key={i}
        isSelected={(selectedTopicle && (topicle.urn || topicle.uri) === (selectedTopicle.urn || selectedTopicle.uri) ? true : false)}
        className='TopicleCell'
        onTopicleSelected={this.handleTopicleSelected}
      />
    ))

    return (
      <div id='scrollableTopicleColumn' className='TopiclesColumn'>
        { infiniteScroll ?
          <div className='TopiclesColumn-list'>
            <InfiniteScroll
              dataLength={topicles.length}
              next={this.props.onFetchMore}
              hasMore={hasMore}
              loader={
                (topicles && !!topicles.length)
                ? <Loader active inline='centered' content='Loading...' size='small' />
                : null
              }
              scrollableTarget='scrollableTopicleColumn'
            >
              {topicleCells}
            </InfiniteScroll>
          </div>
        :
          <div className='TopiclesColumn-list'>
            {topicleCells}
          </div>
        }
        { topicles.length === 0 ? (<p> Keine Ergebnisse </p>) : null }
      </div>
    )
  }
}

export default TopiclesColumn



// WEBPACK FOOTER //
// ./src/probish/TopiclesColumn.js